<ion-content class="window" scrollY=false>
  <div class="container" role="progressbar" tabindex="-1" aria-label="Fetching">
    <div class="content">
      <div class="overlay">
        <span class="ring2" #ring2></span>
      </div>
      <div class="overlay">
        <span class="ring1" #ring1></span>
      </div>
      <div class="text-div"><h2 class="fetching">Fetching</h2></div>
    </div>
  </div>
</ion-content>